// this CODE IS COPIED FROM THE OLD THEME
// TODO REFACTOR THIS CODE
const productUrl = new URL(window.location.href);
const personalizationLine1 = productUrl.searchParams.get("engraving_line_1");
const personalizationLine2 = productUrl.searchParams.get("engraving_line_2");
let cartItemId = productUrl.searchParams.get("item_id");
const cartItemQty = productUrl.searchParams.get("item_quantity");
const BTN_STATUS_SAVED = "saved";
const TOGGLE_SPEED = 420;
const CLOSE_PAYLOAD = "CLOSE";
const CONFIRM_POPUP_MESSAGE = window.engraveSettings.warningMessage;
let CONTROL_FORM = false;
const getScaledFontSize = (fontSize) => {
    if(window.innerWidth >= 990){
        return fontSize;
    } else if(window.innerWidth >= 581){
        return fontSize / 1.2;
    } else if(window.innerWidth >= 375){
        return fontSize / 1.4;
    } else {
        return fontSize / 1.6;
    }
}
function calcTextWidth(text, fontSize, fontFamily) {
  const tag = document.createElement("div");
  tag.style.position = "absolute";
  tag.style.left = "-999em";
  tag.style.whiteSpace = "nowrap";
  tag.style.fontSize = fontSize;
  tag.style.fontFamily = fontFamily;
  tag.innerHTML = text;
  document.body.appendChild(tag);
  const result = tag.clientWidth;
  document.body.removeChild(tag);

  return result;
}
const generateEngraveBox = (mainOption , options,maxLines) => {
  const engraveBoxTemplate = document.createElement("div");
  // TODO MOVE SOME OF THIS STYLING TO CSS
  const scaledFontSize = getScaledFontSize(options.fontSize);
  const optionFontSize = `${scaledFontSize}px`
  engraveBoxTemplate.style.minWidth = `${calcTextWidth("hhhhhhhhhhhhhhh", optionFontSize, 'var(--font-engrave)')}px`;
  engraveBoxTemplate.style.color = options.color;
  engraveBoxTemplate.style.fontSize = optionFontSize;
  engraveBoxTemplate.style.fontFamily = 'var(--font-engrave)';
  engraveBoxTemplate.style.left = `${options.xPos}%`;
  engraveBoxTemplate.style.top = `calc(${options.yPos}%)`;
  engraveBoxTemplate.style.transform = `translate(-50%, -50%) rotate(${options.rotation}deg)`;
  engraveBoxTemplate.style.setProperty('-moz-transform', `translate(-50%, -50%) rotate(${options.rotation}deg)`);
  engraveBoxTemplate.style.overflow = "visible";
  engraveBoxTemplate.style.textAlign = "center";
  engraveBoxTemplate.className = "engrave-box";
  options.connectedInput != 0 && engraveBoxTemplate.classList.add(`engrave-box-only-${options.connectedInput}`);
  if (options.lineAlignment == 'row') {
    engraveBoxTemplate.style.flexDirection = 'row';
    engraveBoxTemplate.style.gap = '4px';
  }
  for (let indexLines = 1; indexLines <= maxLines; indexLines++) {
    var engraveBoxLineTemplate = document.createElement("div");
    var responsiveText = "responsive-text-" + (options.fontSize ? options.fontSize : mainOption.fontSize);
    engraveBoxLineTemplate.classList.add(`engrave-box-line-${indexLines}`, responsiveText);
    engraveBoxTemplate.appendChild(engraveBoxLineTemplate)
  }
  return engraveBoxTemplate;

}
document.addEventListener('DOMContentLoaded', function() {
    const maxLines = Math.max(...[].concat(...Object.keys(window.engraveSettings.options).map(id => window.engraveSettings.options[id].map(rule => rule.lineCount)))) || 1;
    let personalizationPopup = document.querySelector('#PopupModalPersonalization');
    window.engraveSettings.engraveIds.forEach((id, index) => {
        for (let imgIndex = window.engraveSettings.options[id].length - 1; imgIndex >= 0; imgIndex--) {
            const mainOption = window.engraveSettings.options[id][0];
            const options = window.engraveSettings.options[id][imgIndex];
            const engraveBoxTemplate = generateEngraveBox(mainOption,options,maxLines);
            if (document.querySelector(`#engrave-boxes-${(index + 1)}`)){
              document.querySelector(`#engrave-boxes-${(index + 1)}`).appendChild(engraveBoxTemplate);
            }
        }
    });

    const engraveBoxLines1 = document.querySelectorAll('.engrave-box-line-1');
    const engraveBoxLines2 = document.querySelectorAll('.engrave-box-line-2');
    const personalizationInput1 = document.querySelector('#personalizationInput1');
    const personalizationInput2 = document.querySelector('#personalizationInput2');
    const controlLine1 = document.querySelector('#controlLine1');
    const controlLine2 = document.querySelector('#controlLine2');
    const productPropertyLine1 = document.querySelector('#productPropertyLine1');
    const productPropertyLine2 = document.querySelector('#productPropertyLine2');
    const inputCountLine1 = document.querySelector('#inputCountLine1');
    const inputCountLine2 = document.querySelector('#inputCountLine2');
    const personalizationErrorBox = document.querySelector('.personalization-popup__form-error');
    const personalizationInfoBox = document.querySelector('.personalization-popup__info');
    const personalizationReminderInfoBox = document.querySelector('.personalization-popup__reminder-info');
    const personalizationSavedFormBox = document.querySelector('.personalization-popup__form--saved');
    const personalizationFormBox = document.querySelector('.personalization-popup__form');
    const personalizationSaveButton = document.querySelector('#personalizationSaveButton');
    const personalizationConfirmButton = document.querySelector('#personalizationConfirmButton');


    personalizationReminderInfoBox.style.display = 'none';
    personalizationErrorBox.style.display = 'none';
    personalizationSavedFormBox.style.display = 'none';
    personalizationConfirmButton.style.display = 'none';

    if (personalizationLine1 || personalizationLine2) {
        let popupBtn = document.querySelector('#PopupModalPersonalization');
        popupBtn.show();
        if (personalizationLine1) {
            personalizationInput1.value = personalizationLine1;
            engraveBoxLines1.forEach(item => {
                item.innerHTML = personalizationLine1;
            })
            productPropertyLine1.value = personalizationLine1;
            inputCountLine1.innerHTML = personalizationLine1.length;
            controlLine1.innerHTML = personalizationLine1;
        }
        if (personalizationLine1.length > 0 && maxLines > 1) {
            personalizationInput2.disabled = false;
        }
        if (personalizationLine2) {
            personalizationInput2.value = personalizationLine2;
            engraveBoxLines2.forEach(item => {
                item.innerHTML = personalizationLine2;
            })
            productPropertyLine2.value = personalizationLine2;
            inputCountLine2.innerHTML = personalizationLine2.length;
            controlLine2.innerHTML = personalizationLine2;
        }
    }

    personalizationInput1.addEventListener("input", function() {
        let temp_this = this;
        engraveBoxLines1.forEach(item => {
            item.innerHTML = temp_this.value;
        })
        productPropertyLine1.value = this.value;
        inputCountLine1.innerHTML = this.value.length;
        controlLine1.innerHTML = this.value;
    });

    if (maxLines > 1) {
        /* */
        personalizationInput1.addEventListener("input", (event) => {
            if (event.target.value.length > 0) {
                personalizationInput2.disabled = false;
            } else {
                personalizationInput2.disabled = true;
                personalizationInput2.value = '';
                engraveBoxLines2.forEach(item => {
                    item.innerHTML = '';
                })
                productPropertyLine2.value = '';
                inputCountLine2.innerHTML = 0;
                controlLine2.innerHTML = '';
            }
        });
        personalizationInput2.addEventListener("input", function() {
            let temp_this = this;
            engraveBoxLines2.forEach(item => {
                item.innerHTML = temp_this.value;
            })
            productPropertyLine2.value = this.value;
            inputCountLine2.innerHTML = this.value.length;
            controlLine2.innerHTML = this.value;
        });
    } else {
        personalizationInput2.disabled = true;
        personalizationInput2.parentElement.style.display = 'none';
        controlLine2.parentElement.style.display = 'none';
    }


    document.querySelector('#ModalClose-Personalization').addEventListener('click', function(event) {
        event.preventDefault();
        clearForm(CLOSE_PAYLOAD);
    });

    document.querySelectorAll('#personalizationConfirmButton, #personalizationSaveButton').forEach(item => {
        item.addEventListener('click', function(event) {
            event.preventDefault();
            saveForm(CONTROL_FORM);
        });
    })

    document.querySelector('#personalizationAbortButton').addEventListener('click', function(event) {
        event.preventDefault();
        clearForm();
        personalizationPopup.hide();
    });

    document.querySelector('.personalization-popup__form-error .icon-close')
        .addEventListener('click', function(event) {
            event.preventDefault();
            personalizationErrorBox.style.display = 'none';
        });

    document.querySelector('.personalization-popup__form--saved .icon-edit')
        .addEventListener('click', function(event) {
            event.preventDefault();
            personalizationSavedFormBox.style.display = 'none';
            personalizationFormBox.style.display = 'block';
            personalizationSaveButton.style.display = 'block';
            personalizationConfirmButton.style.display = 'none';
            personalizationInfoBox.style.display = 'block';
            personalizationReminderInfoBox.style.display = 'none';
            CONTROL_FORM = false;
        });


    var saveForm = function(controlForm) {
        if (personalizationInput1.value.length || personalizationInput2.value.length) {
            var utf8 = /[\x00-\x7F\u00A0-\u024F\u1E00-\u1EFF\u0370-\u03FF\u0400-\u04FFäöüÄÖÜß]*/g,
                engraveMatchOne = (personalizationInput1.value != personalizationInput1.value.match(utf8)[0]),
                engraveMatchTwo = (personalizationInput2.value != personalizationInput2.value.match(utf8)[0]);

            if ((personalizationInput1.value.length && engraveMatchOne) ||
                (personalizationInput2.value.length && engraveMatchTwo)) {

                personalizationErrorBox.style.display = 'block';
            } else if ((personalizationInput1.value.length && !engraveMatchOne) ||
                (personalizationInput2.value.length && !engraveMatchTwo)) {

                personalizationErrorBox.style.display = 'none';
                personalizationReminderInfoBox.style.display = 'block';
                personalizationSavedFormBox.style.display = 'flex';
                personalizationFormBox.style.display = 'none';
                personalizationSaveButton.style.display = 'none';
                personalizationConfirmButton.style.display = 'block';
                personalizationInfoBox.style.display = 'none';
                if (controlForm && !cartItemId) {
                    let cartModal = document.querySelector('cart-drawer');
                    personalizationPopup.hide();
                    addProductToCart(window.engraveSettings.variantId, 1, cartModal);
                    clearData();
                }
                CONTROL_FORM = true;

                if (controlForm && cartItemId && cartItemQty) {
                    personalizationPopup.hide();
                    updateCartItem(cartItemId, cartItemQty, 'updates[]');
                    cartItemId = null;
                    clearData();
                }
            }
        }
    };
    var clearForm = function(payload) {
        var confirmed = confirm(CONFIRM_POPUP_MESSAGE);
        if (confirmed == true) {
            inputCountLine1.innerHTML = '0';
            inputCountLine2.innerHTML = '0';
            engraveBoxLines1.forEach(item => {
                item.innerHTML = '';
            })
            engraveBoxLines2.forEach(item => {
                item.innerHTML = '';
            })
            personalizationInput1.value = '';
            personalizationInput2.value = '';
            controlLine1.value = '';
            controlLine2.value = '';
            productPropertyLine1.value = '';
            productPropertyLine2.value = '';
            personalizationErrorBox.innerHTML = '';
            CONTROL_FORM = false;
            personalizationErrorBox.style.display = 'none';
            personalizationReminderInfoBox.style.display = 'none';
            personalizationInfoBox.style.display = 'block';
            personalizationSavedFormBox.style.display = 'none';
            personalizationFormBox.style.display = 'block';
            personalizationSaveButton.style.display = 'block';
            personalizationConfirmButton.style.display = 'none';
        }
    };
    function clearData() {
        inputCountLine1.innerHTML = '0';
        inputCountLine2.innerHTML = '0';
        engraveBoxLines1.forEach(item => {
            item.innerHTML = '';
        })
        engraveBoxLines2.forEach(item => {
            item.innerHTML = '';
        })
        personalizationInput1.value = '';
        personalizationInput2.value = '';
        controlLine1.value = '';
        controlLine2.value = '';
        productPropertyLine1.value = '';
        productPropertyLine2.value = '';
        personalizationErrorBox.innerHTML = '';
        CONTROL_FORM = false;
        personalizationErrorBox.style.display = 'none';
        personalizationReminderInfoBox.style.display = 'none';
        personalizationInfoBox.style.display = 'block';
        personalizationSavedFormBox.style.display = 'none';
        personalizationFormBox.style.display = 'block';
        personalizationSaveButton.style.display = 'block';
        personalizationConfirmButton.style.display = 'none';
    }

    function getSectionInnerHTML(html, selector) {
        return new DOMParser()
            .parseFromString(html, 'text/html')
            .querySelector(selector).innerHTML;
    }

    function updateCartItem(line, quantity, name) {
        let cartModal = document.querySelector('cart-drawer');
        const body = JSON.stringify({
            line,
            quantity,
            properties: {
                'engraving_line_1': personalizationInput1.value,
                'engraving_line_2': personalizationInput2.value
            },
            sections: cartModal.getSectionsToRender().map((section) => section.id),
            sections_url: window.location.pathname
        });

        fetch(`${routes.cart_change_url}`, {
                ...fetchConfig(),
                ...{
                    body
                }
            })
            .then((response) => {
                return response.json();
            })
            .then((response) => {
                if (response.status) {
                    console.log("something wrong happened!")
                    return;
                }
                cartModal.renderContents(response);
                // remove param from url
                const url = new URL(window.location.href);
                url.searchParams.delete('item_id');
                url.searchParams.delete('engraving_line_1');
                url.searchParams.delete('engraving_line_2');
                url.searchParams.delete('item_quantity');
                window.history.pushState({}, '', url);
                const lineItem = document.getElementById(`CartItem-${line}`);
                if (lineItem && lineItem.querySelector(`[name="${name}"]`)){
                    lineItem.querySelector(`[name="${name}"]`).focus();
                }
            });
    }

    function addProductToCart(line, quantity, cartModal) {
        cartModal.setActiveElement(document.activeElement);
        const body = JSON.stringify({
            items: [{
                "id": line,
                "quantity": quantity,
                "properties": {
                    'engraving_line_1': personalizationInput1.value,
                    'engraving_line_2': personalizationInput2.value
                }
            }],
            sections: cartModal.getSectionsToRender().map((section) => section.id),
            sections_url: window.location.pathname
        });
        fetch(`${routes.cart_add_url}`, {
                ...fetchConfig(),
                ...{
                    body
                }
            })
            .then((response) => response.json())
            .then((response) => {
                if (response.status) {
                    console.log("something wrong happened!")
                    return;
                }
                cartModal.renderContents(response);
            })
            .catch((e) => {
                console.error(e);
            })
    }
});
